import { render, staticRenderFns } from "./Admin_memMgmt_ler_detail.vue?vue&type=template&id=ca5036b2&"
import script from "./Admin_memMgmt_ler_detail.vue?vue&type=script&lang=js&"
export * from "./Admin_memMgmt_ler_detail.vue?vue&type=script&lang=js&"
import style0 from "./Admin_memMgmt_ler_detail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports